export const userConstants = {
    REGISTER_REQUEST: 'USERS_REGISTER_REQUEST',
    REGISTER_SUCCESS: 'USERS_REGISTER_SUCCESS',
    REGISTER_FAILURE: 'USERS_REGISTER_FAILURE',

    LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
    LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
    LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',

    FETCH_AVATARS_REQUEST: 'FETCH_AVATARS_REQUEST',
    FETCH_AVATARS_SUCCESS: 'FETCH_AVATARS_SUCCESS',
    FETCH_AVATARS_FAILURE: 'FETCH_AVATARS_FAILURE',
    
    LOGOUT: 'USERS_LOGOUT',

    UPDATE_USER: 'USERS_UPDATE_USER',
};
